<script setup lang="ts">
    interface OptionSelectProps {
        option: IProductOption;
        hideHeading?: boolean;
        redCharity?: boolean;
        changeHoverColorOption?: (option: string) => void;
    }
    defineProps<OptionSelectProps>();
</script>
<template>
    <div class="mol-product-option-color flex flex-col gap-3">
        <div class="space-y-2">
            <lazy-atm-heading
                v-if="!hideHeading && option.type.endsWith('(Color)')"
                :level="'span'"
                :size="'sm'">
                {{ option.type.replace('(Color)', '') }}
            </lazy-atm-heading>
            <div class="font-sm flex gap-3 font-mono">
                <span>{{ $t('product.colors', 1) }}: {{ option.selectedRef.value }}</span>
                <lazy-woom-icon-red-charity
                    v-if="redCharity"
                    class="h-6 fill-woom-red" />
            </div>
        </div>
        <mol-color-options
            :options="option.values"
            @changed="(value) => option.setSelected(value)"
            @hover="changeHoverColorOption" />
    </div>
</template>

<style scoped>
    .mol-product-option-color + .mol-product-option-color {
        @apply mt-8;
    }
</style>
